import { render, staticRenderFns } from "./buyinformation.vue?vue&type=template&id=6d8bc830&scoped=true&"
import script from "./buyinformation.vue?vue&type=script&lang=js&"
export * from "./buyinformation.vue?vue&type=script&lang=js&"
import style0 from "./buyinformation.vue?vue&type=style&index=0&id=6d8bc830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8bc830",
  null
  
)

export default component.exports